const defaultNextButtonText = 'Neste';
export default [
    {
        nextButtonText: 'Slik fungerer Trygg betaling',
        topText:
            'Med vår nye betalingsløsning trenger du ikke å være redd for å betale uten å få varen.',
        showFeeDisclaimer: true,
    },
    {
        nextButtonText: defaultNextButtonText,
        body: 'Bli enige om pris og at dere skal bruke Trygg betaling.',
        showProgress: true,
    },
    {
        nextButtonText: defaultNextButtonText,
        body: 'Når begge har godkjent avtalen, betaler kjøper til FINN.',
        showProgress: true,
    },
    {
        nextButtonText: defaultNextButtonText,
        body:
            'FINN gir selger beskjed om at vi har fått betalingen, og at selger kan sende varen.',
        showProgress: true,
    },
    {
        nextButtonText: defaultNextButtonText,
        body: 'Kjøper gir beskjed om at hun har fått varen og alt er i orden.',
        showProgress: true,
    },
    {
        body: 'FINN gir selger pengene.',
        showFeeDisclaimer: true,
        showCancel: true,
        showProgress: true,
    },
];



// WEBPACK FOOTER //
// ./safeTrade/onboarding/onboardingSteps.js